import React from 'react';
import { EVSCCAClass12026 } from '../views';

const DesktopAppPage = () => {
  return <EVSCCAClass12026 />;
};

export default DesktopAppPage;





